var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_839)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6175 16.7999C31.0547 16.7977 30.5165 16.9015 30.0213 17.092L27.351 12.7898C27.277 12.6706 27.1738 12.5722 27.0511 12.5039C26.9284 12.4357 26.7904 12.3999 26.65 12.3999H24.45C24.1463 12.3999 23.9 12.6461 23.9 12.9499V13.4999C23.9 13.8037 24.1463 14.0499 24.45 14.0499H26.1911L26.7032 14.8749H22.8001V14.3249C22.8001 14.0211 22.5538 13.7749 22.2501 13.7749H19.2437C18.7816 13.7749 18.392 14.153 18.4002 14.6149C18.4082 15.0633 18.7741 15.4249 19.2251 15.4249H20.9L19.8888 17.0584C19.4271 16.8924 18.9296 16.8012 18.411 16.7999C15.997 16.7941 14.0142 18.7597 14.0001 21.1736C13.9858 23.6157 15.9613 25.5999 18.4001 25.5999C20.4503 25.5999 22.173 24.1976 22.6614 22.2999H24.4501C24.5906 22.2999 24.7288 22.264 24.8515 22.1956C24.9743 22.1272 25.0776 22.0286 25.1515 21.9092L28.1065 17.1357L28.62 17.963C27.745 18.7691 27.1974 19.9252 27.2 21.2093C27.205 23.5755 29.1903 25.5767 31.5564 25.5997C33.9834 25.6232 35.9626 23.6814 35.9995 21.2685C36.0368 18.83 34.0564 16.8094 31.6175 16.7999V16.7999ZM20.4195 19.3358C20.7539 19.6977 20.9927 20.1492 21.0947 20.6499H19.6061L20.4195 19.3358ZM18.4001 23.9499C16.8837 23.9499 15.6501 22.7163 15.6501 21.1999C15.6501 19.6836 16.8837 18.4499 18.4001 18.4499C18.6018 18.4499 18.7983 18.4723 18.9879 18.5138L17.4236 21.0407C17.084 21.5893 17.4792 22.2999 18.1251 22.2999H20.9198C20.4945 23.2701 19.5254 23.9499 18.4001 23.9499ZM23.9905 20.6499H22.7659C22.6298 19.5583 22.0937 18.591 21.309 17.899L22.1596 16.5249H26.5441L23.9905 20.6499ZM31.4518 23.946C30.0412 23.8716 28.9064 22.7191 28.8521 21.3075C28.8242 20.5815 29.0801 19.9147 29.5168 19.4079L31.0442 21.8686C31.2044 22.1267 31.5434 22.2061 31.8015 22.0459L32.2688 21.7558C32.5269 21.5957 32.6063 21.2566 32.446 20.9985L30.9175 18.5358C31.1405 18.4787 31.3698 18.4498 31.6001 18.4499C33.1164 18.4499 34.3501 19.6836 34.3501 21.1999C34.35 22.7654 33.0352 24.0295 31.4518 23.946V23.946Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_839",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_839"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.beed45596ea0fee8d5fe9d683a09929d.svg";
export { ForwardRef as ReactComponent };